/* eslint-disable max-len */
import React from 'react'
import type { HTMLElementProps } from '~/types'

type Props = HTMLElementProps<'svg'>

export const Truck: React.FC<Props> = ({ stroke = 'currentColor', ...props }) => (
	<svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="none" viewBox="0 0 44 38" {...props}>
		<mask id="truck-mask" fill="black">
			<rect width="100%" height="100%" fill="white" />
			<circle cx="11" cy="31.5" r="5" />
			<circle cx="33" cy="31.5" r="5" />
		</mask>
		<g stroke={stroke} strokeWidth="3.3" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="20">
			<polyline points="26.5,22 26.5,2 2,2 2,31.5 42,31.5 42,19 36,9 26.5,9" mask="url(#truck-mask)" />
			<polyline points="31,13.5 31,19 36.5,19" />
			<circle cx="11" cy="31.5" r="5" />
			<circle cx="33" cy="31.5" r="5" />
		</g>
	</svg>
)
